const initialHeaderStore = { visibleHeader: false, isOpenDrawer: true };

export default initialHeaderStore;
